// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { styled } from '@mui/material/styles';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import SelMemberDialog from './SelMemberDialog';
import DocShareLinkDialog from './DocShareLinkDialog';
import UploadFilesProgress from './UploadFilesProgress';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Chip from '@mui/material/Chip';
import InputAdornment from '@mui/material/InputAdornment';
import DatePicker from '@mui/lab/DatePicker';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';


import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';




export default function DocShareAddDialog(props) {

  const { sysID, open, onClose, docDetail, afterUpdate } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);


  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");


  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }


  // console.log("docDetail", docDetail);

  const [shareMethod, setShareMethod] = useState("1");
  const [selectedEmails, setSelectedEmails] = useState([]);

  const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  const handleDeleteClip = (aClip) => {
    console.log("handleDeleteClip", aClip);
    setSelectedEmails((chips) => chips.filter((chip) => chip.email !== aClip.email));
  }

  const handleCloseClick = () => {
    initData();

    onClose && onClose();
  }

  const initData = () => {

    // setValue("shareMethod", "1");
    setShareMethod("1");

    setSelectedEmails([
      // { email: "ray@hotmail.com", name: 'Angular' },
      // { email: "john@hotmail.com", name: 'John' },
    ]);
    setAddEmail("");
    setMsgInEmail("");
    setPassword("");
    setExpiryDays(0);

  }

  // Use when "open" changed
  useEffect(() => {
    // console.log("useEffect DocCmtAddDialog(open)");

    if (open) {
      initData();

    }

  }, [open])

  // Setup inital form values
  const defaultFormValues = {
    // shareMethod: "1",
  }

  // React Hook the form
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: defaultFormValues
  });

  // const watchShareMethod = watch("shareMethod");


  // const [shareMethod, setShareMethod] = useState('female');

  const handleMethodChange = (event) => {
    // console.log("event.target.value", event.target.value);
    // setShareMethod(event.target.value);
    const vShareMethod = event.target.value;
    // setValue("shareMethod", event.target.value);
    setShareMethod(vShareMethod);

  };

  const handleExpiryDaysChange = (event) => {
    setExpiryDays(event.target.value);
  }

  const handleChangePassword = (event) => {
    setPassword(event.target.value);
  }

  const [addEmail, setAddEmail] = useState("");
  const [msgInEmail, setMsgInEmail] = useState("");


  const onChangeMsgInEmail = (event) => {
    setMsgInEmail(event.target.value);
  }

  const handleChangeAddEmail = (event) => {
    setAddEmail(event.target.value);
  };

  const handleAddEmailClick = () => {
    // console.log("addEmail: ", addEmail);
    if (addEmail.trim() === "") {
      return
    }

    if (DmsCommon.validateEmail(addEmail)) {

      let vEmails = [...selectedEmails];

      const vAddEmail = { email: addEmail, name: '' };

      const findDoc = vEmails.find(e => e.email === vAddEmail.email)
      if (!findDoc) {
        vEmails.push(vAddEmail);
      }

      // const vEmails = [...selectedEmails,
      // { email: addEmail, name: '' },
      // ];
      // console.log("vEmails", vEmails);

      setSelectedEmails(vEmails);
      setAddEmail("");

    } else {
      setErrMsg("Invalid Email!");
      setShowError(true);
    }


  }

  const [password, setPassword] = useState("")
  const [expiryDays, setExpiryDays] = useState(0)




  const [openAddUserDialog, setOpenAddUserDialog] = useState(false);
  const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const handleAddByUsersClick = () => {
    setShowLoading(true);

    const p1 = DmsService.getMembersPromise(gState.sessionID, sysID, false);
    const p2 = DmsService.getGroupsPromise(gState.sessionID, sysID);

    Promise.all([p1, p2]).then((values) => {
      setShowLoading(false);
      // console.log("Promise.all", values);

      const [v1, v2] = values;

      setMembers(v1);
      setGroups(v2);
      setOpenAddUserDialog(true);
    })
      .catch(e => {
        setShowLoading(false);
        onCatchPromiseError(e);
      })
  }

  const handleSelectAddUsers = (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    setOpenAddUserDialog(false);

    const vUserIDs = aUsers.map(item => item.UserID);
    const vGroupIDs = aGroups.map(item => item.GroupID);

    // console.log("vUserIDs", vUserIDs);
    // console.log("vGroupIDs", vGroupIDs);

    setShowLoading(true);

    DmsService.getEmailListByUsernamePromise(gState.sessionID, sysID, vUserIDs, vGroupIDs)
      .then((data) => {
        setShowLoading(false);
        // console.log("Promise.all", values);
        const returnEmails = data.map(d => {
          return { email: d.Email, name: d.Name }
        })

        let vEmails = [...selectedEmails];

        returnEmails.forEach(item => {

          const findDoc = vEmails.find(e => e.email === item.email)
          if (!findDoc) {
            vEmails.push(item);
          }
        })

        setSelectedEmails(vEmails);


      })
      .catch(e => {
        setShowLoading(false);
        onCatchPromiseError(e);
      })


  }

  const refInputEmail = React.useRef();

  const [openShareLinkDialog, setOpenShareLinkDialog] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const handleShareLinkDialogClose = () => {
    setOpenShareLinkDialog(false);

    afterUpdate && afterUpdate();
  }

  const [showEmailSentDialog, setShowEmailSentDialog] = useState(false);
  const handleEmailSentDialogClose = () => {
    setShowEmailSentDialog(false);

    afterUpdate && afterUpdate();
  }


  const onSubmit = data => {
    // console.log("onSubmit", data);

    // console.log("password", password);
    // console.log("expiryDays", expiryDays);

    if (shareMethod == "1") {
      setShowLoading(true);

      DmsService.shareFileByLinkPromise(gState.sessionID, sysID, docDetail.DocID, password, expiryDays)
        .then((data) => {
          setShowLoading(false);
          console.log("shareFileByLinkPromise data", data);

          if (data && data.length > 0) {
            setShareLink(data[0].link);
          }

          setOpenShareLinkDialog(true);

        })
        .catch(e => {
          setShowLoading(false);
          onCatchPromiseError(e);
        })
    } else {

      if (selectedEmails.length == 0) {
        refInputEmail.current && refInputEmail.current.focus();

        setErrMsg("Please input at least 1 email!");
        setShowError(true);

        return
      }

      // console.log("selectedEmails", selectedEmails);
      const vEmails = selectedEmails.map(e => e.email);
      // console.log("vEmails", vEmails);


      setShowLoading(true);

      DmsService.sendEmailForShareDmsDocPromise(gState.sessionID, sysID, docDetail.DocID, vEmails,
        msgInEmail, password, expiryDays)
        .then(() => {
          setShowLoading(false);

          setShowEmailSentDialog(true);

        })
        .catch(e => {
          setShowLoading(false);
          onCatchPromiseError(e);
        })
    }

  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
      aria-describedby="doc-add-share-dialog-description"
    >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />
      <MsgDialog
        open={showEmailSentDialog}
        msgText="Email Sent!"
        onClose={handleEmailSentDialogClose}
      />
      <DocShareLinkDialog
        open={openShareLinkDialog}
        shareLink={shareLink}
        onClose={handleShareLinkDialogClose}
      />
      {/* <Snackbar
        open={openToast}
        autoHideDuration={2000}
        onClose={() => setOpenToast(false)}
      >
        <Alert elevation={6} variant="filled" severity="success" sx={{ width: '100%' }}>
          Email Sent!
        </Alert>
      </Snackbar> */}

      <DialogTitle id="alert-dialog-title">
        Share Document ({docDetail.Subject})
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh" }} component="form" onSubmit={handleSubmit(onSubmit)} >
          <TextField
            label="Share File" value={docDetail.Filename}
            fullWidth
            sx={{ my: 1 }}
            InputLabelProps={{ shrink: true, }}
          />

          <FormControlLabel
            checked={shareMethod === "1"}
            onChange={handleMethodChange}
            value="1"
            control={<Radio />}
            label="Link"
          />

          <FormControlLabel
            checked={shareMethod === "2"}
            onChange={handleMethodChange}
            value="2"
            control={<Radio />}
            label="Email"
          />


          {shareMethod === "2" &&
            <React.Fragment>

              <Box sx={{ display: 'flex', alignItems: 'center', }} >
                <TextField
                  label="Add Email"
                  inputRef={refInputEmail}
                  value={addEmail}
                  onChange={handleChangeAddEmail}

                  sx={{ m: 1, width: "400px" }}
                  InputLabelProps={{ shrink: true, }}
                  InputProps={{
                    endAdornment:
                      <InputAdornment position="end">
                        <Button onClick={() => handleAddEmailClick()}>
                          Add
                        </Button>
                      </InputAdornment>
                  }}
                  onKeyPress={(event) => {

                    if (event.key == 'Enter') {
                      event.preventDefault();
                      // console.log("Pressed enter");
                      handleAddEmailClick();

                    }
                  }}
                />
                <Button onClick={() => handleAddByUsersClick()}>
                  Add from Users
                </Button>
                <SelMemberDialog
                  open={openAddUserDialog}
                  onClose={() => { setOpenAddUserDialog(false) }}
                  members={members}
                  groups={groups}
                  onSelect={handleSelectAddUsers}
                />
              </Box>

              <Box sx={{ mx: 1 }}>
                Send to (unique by email):
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  listStyle: 'none',
                  p: 0.5,
                  m: 0,
                  minHeight: '60px',
                }}
                component="ul"
              >
                {selectedEmails.map((data) => {

                  return (

                    <ListItem key={data.email}>
                      <Chip
                        label={data.name ? `${data.name} <${data.email}>` : `${data.email}`}
                        onDelete={() => handleDeleteClip(data)}
                      />
                    </ListItem>
                  );
                })}
              </Box>

              <TextField
                label="Message to Recipient(s) (Optional)"
                fullWidth
                multiline
                value={msgInEmail}
                onChange={onChangeMsgInEmail}
                minRows={6}
                maxRows={6}
                InputLabelProps={{ shrink: true, }}

              />


            </React.Fragment>

          }

          <Box sx={{ mt: 2 }}>

            <TextField
              variant="filled"
              label="Password (Optional)"
              value={password}
              onChange={handleChangePassword}
              sx={{ m: 1, width: "200px" }}
              InputLabelProps={{ shrink: true, }}
            />

            {/* <DatePicker
              label="Expiry Date (Optional)"
              type="date"
              value={expiryDays}
              onChange={handleExpiryDaysChange}

              renderInput={(params) => <TextField
                sx={{ m:1, width: "200px" }}
                {...params}
                InputLabelProps={{ shrink: true, }}
              />}
            /> */}
            <TextField
              select
              label="Expiry after (Optional)"
              variant="filled"
              id="select-expiry"
              sx={{ m: 1, width: "200px" }}
              value={expiryDays}
              onChange={handleExpiryDaysChange}
            >
              <MenuItem value={0}>N/A</MenuItem>
              <MenuItem value={1}>1 Day</MenuItem>
              <MenuItem value={5}>5 Days</MenuItem>
              <MenuItem value={10}>10 Days</MenuItem>
              <MenuItem value={30}>30 Days</MenuItem>
              <MenuItem value={90}>90 Days</MenuItem>
              <MenuItem value={180}>180 Days</MenuItem>
            </TextField>
          </Box>




          <Box sx={{ textAlign: 'right', mt: 1 }} >

            <Button onClick={handleCloseClick}>Cancel</Button>
            <Button type="submit" variant="contained"  >
              OK
            </Button>
          </Box>

        </Box>


      </DialogContent>
      <DialogActions>

      </DialogActions>
    </Dialog>

  );
}

DocShareAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  docDetail: PropTypes.object,
  afterUpdate: PropTypes.func,
};
